import { render, staticRenderFns } from "./fz-footer.vue?vue&type=template&id=1dd53456&scoped=true&"
var script = {}
import style0 from "./fz-footer.vue?vue&type=style&index=0&id=1dd53456&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd53456",
  null
  
)

export default component.exports